var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    fill: "#212529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "budicon-shopping-bag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.858 21H3.142l-.14 2.952A1 1 0 0 0 4 25h16a1 1 0 0 0 .999-1.048z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.094 4.952A1 1 0 0 0 19.095 4H16a4 4 0 0 0-8 0H4.905a1 1 0 0 0-.999.952L3.19 20h17.62zM9 8.5a.5.5 0 0 1-1 0V5h1zM12 1a3.003 3.003 0 0 1 3 3H9a3.003 3.003 0 0 1 3-3zm4 7.5a.5.5 0 1 1-1 0V5h1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/ShoppingBag.d69712976fbde11defe006e950a44af8.svg";
export { ForwardRef as ReactComponent };